import { useEffect, useState } from "react";
import { Grid, Card, Statistic, Typography, Message, Button, Space } from "@arco-design/web-react";
import { getStats, type DashboardStats } from "../api/dashboard.js";
import { parseApiError } from "../api/http.js";

const { Row, Col } = Grid;
const { Title } = Typography;

export function DashboardPage(): JSX.Element {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);

  const load = (): void => {
    setLoading(true);
    getStats()
      .then(setStats)
      .catch((err: unknown) => Message.error(parseApiError(err).message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="os-stack">
      <div className="os-row" style={{ justifyContent: "space-between" }}>
        <Title heading={5} style={{ margin: 0 }}>
          运行概况
        </Title>
        <Space>
          <Button onClick={load} loading={loading}>
            刷新
          </Button>
        </Space>
      </div>
      <Row gutter={[12, 12]}>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic title="累计同步订单" value={stats?.orders_total ?? "-"} loading={loading} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic title="24h 同步订单" value={stats?.orders_24h ?? "-"} loading={loading} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic title="队列中事件" value={stats?.queued_events ?? "-"} loading={loading} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic title="死信事件" value={stats?.dead_events ?? "-"} loading={loading} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic title="24h 错误数" value={stats?.errors_24h ?? "-"} loading={loading} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="最近同步时间"
              value={stats?.last_synced_at ? new Date(stats.last_synced_at).toLocaleString() : "-"}
              loading={loading}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
